import React from 'react';
import moment from 'moment';

// Kept as the date display used by reader rows. The old chart methods were
// never called by render and only kept an unused Semantic UI dependency alive.
export const ReadingGraph = ({ date, failureMessage }) => {
  if (!date) return failureMessage || null;
  const parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime())) return failureMessage || null;
  const value = moment(parsedDate);
  return (
    <>
      <time dateTime={parsedDate.toISOString()}>{value.fromNow()}</time>
      <br />
      <span style={{ fontSize: '0.8em', color: 'var(--br-muted)' }}>{value.format('L')}</span>
    </>
  );
};

export default ReadingGraph;
